
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MixedWidget102 } from "../../../../../../../_metronic/partials/widgets/mixed/MixedWidget102"

export const ViewModal = ({ id, data, close }) => {
  const [analytics, setAnalytics] = useState<any>(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      if (!data?.id) return;
      try {
        const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
        const token = authData?.data?.token;

        const response = await axios.get(`https://fts-backend-api.asmglobal.co.in/v1/api/map/analytics`, {
          params: { customerId: data.id },
          headers: {
            'Authorization': token,
            'app-id': '3',
            'client-id': '101212',
            'accept': 'application/json'
          }
        });
        setAnalytics(response.data);
      } catch (error) {
        console.error('Error fetching analytics:', error);
      }
    };
    fetchAnalytics();
  }, [data?.id]);

  return (
    <>
      <div className="modal-overlay" onClick={close}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Plastic Keeper details</h3>
            <button className="close-button" onClick={close}>
              ×
            </button>
          </div>
          <div className="modal-body">
            <div className="location-info">
              <div className="location-details">
                <div className="location-image">
                  <img
                    src={
                      data?.kycDocument?.[0]?.docUrl ||
                      'https://via.placeholder.com/100'
                    }
                    alt={data?.personalDetails?.name || 'User'}
                    className="location-img"
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <p style={{ display: 'flex', margin: 0 }}>
                    <strong style={{ minWidth: '120px', marginRight: '2px' }}>Name:</strong>
                    <span>{data?.personalDetails?.name || 'N/A'}</span>
                  </p>
                  <p style={{ display: 'flex', margin: 0 }}>
                    <strong style={{ minWidth: '120px', marginRight: '2px' }}>Status:</strong>
                    <span
                      className={data?.active ? 'badge badge-light-success fw-bold' : 'badge fw-bold'}
                      style={data?.active !== true ? { backgroundColor: '#fff8dd', color: '#fbd124' } : undefined}
                    >
                      {data?.active ? 'ACTIVE' : 'INACTIVE'}
                    </span>
                  </p>
                  <p style={{ display: 'flex', margin: 0 }}>
                    <strong style={{ minWidth: '120px', marginRight: '2px' }}>Mobile:</strong>
                    <span>{data?.personalDetails?.mobile || 'N/A'}</span>
                  </p>
                  <p style={{ display: 'flex', margin: 0 }}>
                    <strong style={{ minWidth: '120px', marginRight: '2px' }}>Address:</strong>
                    <span>
                      {data?.address?.street
                        ? `${data.address.street}${data.address.city ? ', ' + data.address.city : ''}${data.address.country ? ', ' + data.address.country : ''}`
                        : 'N/A'}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* 4 Cards - Daily, Monthly, Annual, Lifetime */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '20px' }}>
              <div style={{ display: 'flex', gap: '16px' }}>
                <div style={{
                  flex: 1,
                  backgroundColor: '#ffffff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '80px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Daily avg</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#7239ea' }}>
                    {data?.avgDailyCollected?.toFixed(2) || '0.00'}
                  </div>
                </div>
                <div style={{
                  flex: 1,
                  backgroundColor: '#ffffff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '80px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Monthly avg</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#ffc700' }}>
                    {data?.avgMonthlyCollected?.toFixed(2) || '0.00'}
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '16px' }}>
                <div style={{
                  flex: 1,
                  backgroundColor: '#ffffff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '80px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Annual avg</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#5099ff' }}>
                    {data?.avgYearlyCollected?.toFixed(2) || '0.00'}
                  </div>
                </div>
                <div style={{
                  flex: 1,
                  backgroundColor: '#ffffff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '80px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Lifetime</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#7239ea' }}>
                    {data?.lifeTimePerformance?.toFixed(2) || '0.00'}
                  </div>
                </div>
              </div>
            </div>
          </div>


          {analytics?.data?.weeklyCollection && <MixedWidget102
            className=''
            chartColor='info'
            chartHeight='150px'
            title="Collection trend"
            subtitle="Last 7 days"
            amount={analytics?.data?.totalWeeklyCollection}
            chartData={analytics?.data?.weeklyCollection}
            seriesName="Quantity"
          />}

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={close}>
              Close
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          border-radius: 8px;
          max-width: 600px;
          width: 95%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #eee;
        }

        .modal-header h3 {
          margin: 0;
          font-size: 1.25rem;
        }

        .close-button {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #666;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-button:hover {
          color: #000;
        }

        .modal-body {
          padding: 20px;
        }

        .location-info {
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #eee;
        }

        .location-details {
          display: flex;
          align-items: flex-start;
          gap: 20px;
        }

        .location-image {
          flex-shrink: 0;
        }

        .location-img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #e9ecef;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .modal-footer {
          padding: 20px;
          border-top: 1px solid #eee;
          text-align: right;
        }

        .btn {
          padding: 6px 14px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 13px;
        }

        .btn-secondary {
          background-color: #6c757d;
          color: white;
        }

        .btn-secondary:hover {
          background-color: #545b62;
        }
      `}</style>
    </>
  )
}